import React, { useContext, useState } from "react";
import { Fragment } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AppContext } from "../context/AppContext";
import * as Bs from "react-icons/bs";
import Utils from "../utils/Utils";
import { toast } from "react-toastify";

import * as Io5 from "react-icons/io5";
import * as Fa from "react-icons/fa";
import * as Ri from "react-icons/ri";
import { Modal, Switch } from "antd";
import { useNavigate } from "react-router-dom";

import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";


function PromotionList() {
  const {
    promotion,
    deletePromotion,
    getPromotions,
    promotionLoading,
    changePromotionStatus,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [action, setAction] = useState(null);
  const [selectedRemoveIndex, setSelectedRemoveIndex] = useState(-1);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [expandedRow, setExpandedRow] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteValues, setDeleteValues] = useState({
    id: -1,
    index: -1,
  });
  const [selectedImg, setSelectedImg] = useState(null);
  const [viewImgModal, setViewImgModal] = useState(false);

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const toggleAction = (index) => {
    setAction((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleOpenModal = (id, index) => {
    setDeleteValues({ id, index });
    setConfirmModal(true);
  };
  const handleDeletePromotion = async () => {
    const { id, index } = deleteValues;
    if (!id || id < 0) return;
    const token = localStorage.getItem("UserRetention");
    const headers = {
      "x-user": token,
    };
    try {
      setSelectedRemoveIndex(index);
      await deletePromotion(id, {
        onSuccess: async (res) => {
          toast.success("Promotion is deleted successfully");
          setSelectedRemoveIndex(-1);
          setAction(-1);
          await getPromotions(token);
        },
        onFailed: (err) => {
          toast.error("Something went wrong");
          console.log(err, "error");
        },
        headers: headers,
      });
    } finally {
      setSelectedRemoveIndex(-1);
      setConfirmModal(false);
      setDeleteValues({
        id: -1,
        index: -1,
      });
    }
  };
  const handleNavigation = (data) => {
    console.log(data, "data");
    window.location.href = `/edit-promotion/${data?.offerId}`;
  };

  const updatePromotionStatus = async (id, index, status) => {
    if (!id) return;
    const token = localStorage.getItem("UserRetention");
    const headers = {
      "x-user": token,
    };

    const alteredStatus = status === true ? false : true;

    try {
      setSelectedIndex(index);
      await changePromotionStatus(id, {
        onSuccess: async (res) => {
          toast.info(
            `Promotion is ${
              alteredStatus == true ? "Activated" : "Deactivated"
            }`
          );
          await getPromotions(token);
        },
        onFailed: (err) => {
          toast.error("Status not changed! Please try again!");
          console.log("Promoiton status change error", err);
        },
        headers: headers,
      });
    } finally {
      setSelectedIndex(-1);
      setAction(null);
    }
  };

  return (
    <Fragment>
      <Modal
        open={viewImgModal}
        onCancel={() => setViewImgModal(false)}
        okButtonProps={{ style: { display: "none" } }}
      >
        <div className="preview_wrapper">
          <img src={selectedImg} alt="modal-img" className="img_preview" />
        </div>
      </Modal>
      <Modal
        open={confirmModal}
        footer={null}
        onCancel={() => setConfirmModal(false)}
      >
        <div className="modal-content">
          <h3>Confirm Deletion</h3>
          <p>
            Are you sure you want to delete this promotion? This action cannot
            be undone.
          </p>
          <div className="modal-actions">
            <button
              className="confirm-btn_"
              onClick={handleDeletePromotion}
              disabled={promotionLoading}
            >
              {!promotionLoading ? (
                "Yes, Delete"
              ) : (
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
            </button>
            <button
              className="cancel-btn"
              onClick={() => setConfirmModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <MasterLayout>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <h6 className="my-3 mx-3">Promotion List</h6>
            </div>
          </div>
          <div className="card  w-100">
            <div className="table-responsive scroll-sm p-3">
              <table className="table bordered-table text-sm ">
                <thead className="table-light sticky-top">
                  <tr>
                    <th style={{ width: 60 }} className="text-center">
                      #
                    </th>
                    <th style={{ minWidth: 240 }}>Title</th>
                    <th style={{ width: 150 }}>Web Pos.</th>
                    <th style={{ width: 150 }}>Mobile Pos.</th>
                    <th style={{ width: 120 }} className="text-center">
                      Status
                    </th>
                    <th style={{ width: 220 }} className="text-end">
                      Actions
                    </th>
                    <th style={{ width: 60 }} className="text-center">
                      More
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Array.isArray(promotion) && promotion.length > 0 ? (
                    promotion.map((data, index) => {
                      const [startDate, startTime] = (
                        data?.startDate || ""
                      ).split(" ");
                      const [endDate, endTime] = (data?.endDate || "").split(
                        " "
                      );
                      const locs = data?.locations
                        ? data.locations
                            .split(",")
                            .map((s) => s.trim())
                            .filter(Boolean)
                        : [];

                      return (
                        <React.Fragment key={data?.offerId ?? index}>
                          <tr>
                            <td className="text-center text-muted">
                              {index + 1}
                            </td>

                            <td>
                              <div className="fw-semibold">
                                {data?.title || "—"}
                              </div>
                              <div className="text-muted small">
                                {startDate && (
                                  <>
                                    {startDate}
                                    {startTime
                                      ? ` • ${Utils.convertTiming(startTime)}`
                                      : ""}
                                    {" — "}
                                  </>
                                )}
                                {endDate && (
                                  <>
                                    {endDate}
                                    {endTime
                                      ? ` • ${Utils.convertTiming(endTime)}`
                                      : ""}
                                  </>
                                )}
                              </div>
                              {!!locs.length && (
                                <div className="d-flex flex-wrap gap-1 mt-1">
                                  {locs.map((l, i) => (
                                    <span
                                      key={i}
                                      className="badge rounded-pill text-bg-light"
                                    >
                                      {l.toUpperCase()}
                                    </span>
                                  ))}
                                </div>
                              )}
                            </td>

                            <td>
                              {data?.wPosition ? (
                                <span className="badge text-bg-info-subtle border border-info-subtle">
                                  {data.wPosition}
                                </span>
                              ) : (
                                <span className="">—</span>
                              )}
                            </td>

                            <td>
                              {data?.mPosition ? (
                                <span className="badge text-bg-info-subtle border border-primary-subtle">
                                  {data.mPosition}
                                </span>
                              ) : (
                                <span className="">— -</span>
                              )}
                            </td>

                            <td className="text-center">
                              <Switch
                                disabled={promotionLoading}
                                onClick={() =>
                                  updatePromotionStatus(
                                    data?.offerId,
                                    index,
                                    data?.active
                                  )
                                }
                                checked={!!data?.active}
                              />
                            </td>

                            <td className="text-end">
                              <div className="seg-btn">
                                <button
                                  type="button"
                                  className="seg-btn__item seg-btn__item--edit"
                                  onClick={() =>
                                    (window.location.href = `/edit-promotion/${data?.offerId}`)
                                  }
                                  title="Edit"
                                >
                                  <Ri.RiEdit2Line className="seg-btn__icon" />
                                  <span>Edit</span>
                                </button>

                                <button
                                  type="button"
                                  className="seg-btn__item seg-btn__item--delete"
                                  onClick={() =>
                                    handleOpenModal(data?.offerId, index)
                                  }
                                  disabled={promotionLoading}
                                  title="Delete"
                                >
                                  <Fa.FaRegTrashAlt className="seg-btn__icon" />
                                  <span>Delete</span>
                                </button>
                              </div>
                            </td>

                            <td className="text-center">
                              <button
                                type="button"
                                className="toggle-btn"
                                onClick={() => toggleRow(index)}
                                aria-expanded={expandedRow === index}
                                aria-controls={`promo-row-${index}`}
                                title={
                                  expandedRow === index ? "Collapse" : "Expand"
                                }
                              >
                                {expandedRow === index ? (
                                  <Fa.FaChevronUp />
                                ) : (
                                  <Fa.FaChevronDown />
                                )}
                              </button>
                            </td>
                          </tr>

                          {expandedRow === index && (
                            <tr
                              id={`promo-row-${index}`}
                              className="table-active"
                            >
                              <td colSpan={7}>
                                <div className="p-3 bg-body-tertiary rounded-2">
                                  <div className="row g-3">
                                    <div className="col-lg-6">
                                      <div className="mb-1">
                                        <strong>Promotion For:</strong>{" "}
                                        <span className="text-capitalize">
                                          {data?.promotionFor || "—"}
                                        </span>
                                      </div>

                                      {data?.redirectWebLink && (
                                        <div className="mb-1">
                                          <strong>Redirection Link:</strong>{" "}
                                          <a
                                            className="link-primary"
                                            href={data.redirectWebLink}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            {data.redirectWebLink}
                                          </a>
                                        </div>
                                      )}

                                      <div className="mb-1">
                                        <strong>Offer Code:</strong>{" "}
                                        {data?.offerCode || "—"}
                                      </div>

                                      <div className="mb-1">
                                        <strong>Payment Type:</strong>{" "}
                                        {data?.paymentType === "fixedPrice"
                                          ? "Fixed Price"
                                          : data?.paymentType === "DiscountAmt"
                                          ? "Discount Amount"
                                          : "—"}
                                      </div>

                                      <div className="mb-1">
                                        <strong>Price:</strong>{" "}
                                        {data?.price ?? 0}
                                        {" • "}
                                        <strong>Discount:</strong>{" "}
                                        {data?.discount_price ?? 0}
                                      </div>

                                      <div className="mb-1">
                                        <strong>Locations:</strong>{" "}
                                        {data?.locations
                                          ? data.locations.toUpperCase()
                                          : "—"}
                                      </div>

                                      <div className="mb-0 exp_desc">
                                        <strong>Description:</strong>{" "}
                                        {data?.description ||
                                          "No description available"}
                                      </div>
                                    </div>

                                    <div className="col-lg-6">
                                      <div className="d-flex flex-wrap gap-3 image-gallery">
                                        {data?.file?.length ? (
                                          <PhotoProvider>
                                            <PhotoView src={data.file}>
                                              <img
                                                src={data.file}
                                                alt="Primary"
                                                className="expanded-img rounded-2 border"
                                              />
                                            </PhotoView>
                                          </PhotoProvider>
                                        ) : null}

                                        {data?.wFile?.length ? (
                                          <PhotoProvider>
                                            <PhotoView src={data.wFile}>
                                              <img
                                                src={data.wFile}
                                                alt="Secondary"
                                                className="expanded-img rounded-2 border"
                                              />
                                            </PhotoView>
                                          </PhotoProvider>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center py-5 text-muted">
                        No promotions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </MasterLayout>
    </Fragment>
  );
}

export default PromotionList;
